import React, { Fragment, Component } from "react";
import styles from "./AccountCardWrapper.module.less";
import classNames from "classnames";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import AccountNumber from "../AccountNumber/AccountNumber";
import DisclaimerId from "../../containers/secure/Dashboard/AccountList/AccountCard/DisclaimerId/DisclaimerId";
import DetailList, { DetailListItem } from "../DetailList/DetailList";
const messages = defineMessages({
    referenceNumber: {
        id: "dashboard.accountList.accountCard.referenceNumber",
        defaultMessage: "Reference #"
    },
    accountNumber: {
        id: "dashboard.accountList.accountCard.accountNumber",
        defaultMessage: "Account #"
    },
    creditor: {
        id: "dashboard.accountList.accountCard.creditor",
        defaultMessage: "Creditor"
    }
});
const AccountCardWrapper = ({ children, className, ...props }) => (<div {...props} className={classNames("vr vr_x2", className)}>
		<div className={styles.card}>
			{children}
		</div>
	</div>);
AccountCardWrapper.Content = ({ children }) => (<div className={styles.content}>
		{children}
	</div>);
class Title extends Component {
    render() {
        const { disclaimerIds } = this.props;
        return (<div className={styles.title}>
				{this._renderTitle()}
				<DisclaimerId value={disclaimerIds || null}/>
			</div>);
    }
    _renderTitle() {
        const { group } = this.props;
        if (group.accounts.length > 1) {
            return (<FormattedMessage id="dashboard.accountList.accountCard.multipleAccounts" defaultMessage="Multiple Accounts"/>);
        }
        const account = group.primary;
        const acctNum = (<AccountNumber value={account.acctNum}/>);
        return (<Fragment>
				{(process.env.CLIENT == null || account.creditor != null) && (<Fragment>
						{account.creditor} ({acctNum})
					</Fragment>)}
				{process.env.CLIENT != null && account.creditor == null && (acctNum)}
			</Fragment>);
    }
}
AccountCardWrapper.Title = injectIntl(Title);
AccountCardWrapper.Details = ({ refNum, children, ...props }) => (<div {...props}>
		<DetailList>
			<DetailListItem label={messages.referenceNumber}>
				{refNum}
			</DetailListItem>
			{children}
		</DetailList>
	</div>);
export default AccountCardWrapper;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/AccountCardWrapper/AccountCardWrapper.tsx